import axios from "@/api/axiosInstance";
import {
  UpdateLibraryModuleRequest,
  UpdateLibraryModuleResponse,
} from "./types";

export const updateLibraryModule = async (
  uuid: string,
  requestData: UpdateLibraryModuleRequest,
): Promise<UpdateLibraryModuleResponse> => {
  const response = await axios.put<UpdateLibraryModuleResponse>(
    `/api/private/learning-center/module-library/${uuid}`,
    requestData,
  );
  return response.data;
};
